import { useState, useMemo, createContext } from "react";

export const MainContext = createContext();

export const useMainContext = () => {
  const [isNavOpen, setIsNavOpen] = useState(true);

  return useMemo(() => ({ isNavOpen, setIsNavOpen }), [isNavOpen]);
};
